<template>
  <img
    v-if="media"
    class="max-h-10 w-20"
    :src="media.original_url"
    alt=""
    width="80"
    height="40"
  >
  <span
    v-else
    class="text-gray-500 uppercase text-sm font-semibold"
  >
    {{ attributeValue.default_value.text_translated }}
  </span>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  attributeValue: {
    type: Object,
    required: true,
  },
  defaultLocale: {
    type: String,
    required: true,
  },
});

const media = computed(() => {
  const { medias } = props.attributeValue.default_value;
  return medias.find((item) => item.custom_properties.locale === props.defaultLocale) || medias.at(0);
});

</script>
